import { render, staticRenderFns } from "./telRecordView.vue?vue&type=template&id=705cec4b&scoped=true&"
import script from "./telRecordView.vue?vue&type=script&lang=js&"
export * from "./telRecordView.vue?vue&type=script&lang=js&"
import style0 from "./telRecordView.vue?vue&type=style&index=0&id=705cec4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cec4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705cec4b')) {
      api.createRecord('705cec4b', component.options)
    } else {
      api.reload('705cec4b', component.options)
    }
    module.hot.accept("./telRecordView.vue?vue&type=template&id=705cec4b&scoped=true&", function () {
      api.rerender('705cec4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/telRecordView.vue"
export default component.exports